
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 22c4.253 0 8-3 8-7s-3-6-4-7c-1.406-1.406-1.848-3.254-1.975-4.525-.07-.704-.75-1.204-1.339-.813C11.534 3.427 9.904 4.987 9 8c-.643 2.142 0 4 0 4s-1-.5-1.5-2a51.461 51.461 0 00-.603-1.683c-.316-.843-1.456-.836-1.734.021C4.615 10.028 4 12.303 4 14c0 5 3.747 8 8 8z"}})])
          )
        }
      }
    